import withProps from 'recompose/withProps';
import trackLinkFactory from 'src/client/js/analytics/factory/link';

export const withOnTrackLinkHandler = withProps({
  onTrackLink: config => trackLinkFactory(config)
});

export default withOnTrackLinkHandler;
